// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c36e669e","131":"36dd80b9","164":"6eaeaa13","240":"58482c9d","366":"b0d71c17","453":"4825beaa","470":"1899cd75","554":"68a1b372","613":"9c3a27ab","745":"4404142d","824":"45844fa8","851":"e0c63978","934":"849147d5"}[chunkId] + ".chunk.js";
};